declare var System;
System.config({
    map: {
        app: 'sources/js/Main'
    }
});